<template>
  <section class="shell">
    <aside v-if="hasBackofficeAccess" :class="{ expanded }">
      <nav>
        <ul class="nav-list">
          <li class="nav-list-item">
            <router-link to="/" exact
              ><span><p-icon name="home"></p-icon></span>Overview</router-link
            >
          </li>
          <li v-if="$hasPermission('portfolio.read')" class="nav-list-item">
            <router-link to="/portfolio"
              ><span><p-icon name="portfolio"></p-icon></span>Portfolio</router-link
            >
          </li>
          <li v-if="$hasPermission('portfolio.read')" class="nav-list-item">
            <router-link to="/pipelines"
              ><span><p-md-icon name="pipe-disconnected"></p-md-icon></span>Pipelines</router-link
            >
          </li>
          <li v-if="$hasPermission('users.read')" class="nav-list-item">
            <router-link to="/people"
              ><span><p-md-icon name="account-multiple"></p-md-icon></span>People</router-link
            >
          </li>
          <li v-if="$hasPermission('users.read')" class="nav-list-item">
            <router-link to="/teams"
              ><span><p-md-icon name="account-group"></p-md-icon></span>Teams</router-link
            >
          </li>
          <li v-if="$hasPermission('organizations.read')" class="nav-list-item">
            <router-link to="/organizations"
              ><span><p-md-icon name="office-building"></p-md-icon></span>Organizations</router-link
            >
          </li>
          <li v-if="$hasPermission('specifications.read')" class="nav-list-item">
            <router-link to="/specifications"
              ><span><p-icon name="specifications"></p-icon></span>Specifications</router-link
            >
          </li>
          <li v-if="showNlp" class="nav-list-item nlp-menu" :class="{ active: isNlpRoute }">
            <div
              ref="nlpTrigger"
              class="nlp-trigger"
              :class="{ open: nlpOpen, active: isNlpRoute }"
              role="button"
              tabindex="0"
              @click.stop="toggleNlp"
              @keydown.enter.prevent="toggleNlp"
              @keydown.space.prevent="toggleNlp"
            >
              <span><p-md-icon name="robot"></p-md-icon></span>
              NLP / LLMs
              <span class="chevron"><p-md-icon :name="nlpOpen ? 'chevron-down' : 'chevron-right'"></p-md-icon></span>
            </div>
            <div v-if="nlpOpen" class="nlp-dropdown" :style="nlpDropdownStyle" @click.stop>
              <ul class="nlp-dropdown-list">
                <li v-if="$hasPermission('prompts.read')">
                  <router-link to="/chains" @click.native="closeNlp">
                    <span><p-icon name="chain"></p-icon></span>Content Chains
                  </router-link>
                </li>
                <li v-if="$hasPermission('prompts.read')">
                  <router-link to="/tools" @click.native="closeNlp">
                    <span><p-md-icon name="hammer-screwdriver"></p-md-icon></span>Tools
                  </router-link>
                </li>
                <li v-if="$hasPermission('skills.read')">
                  <router-link to="/skills" @click.native="closeNlp">
                    <span><p-md-icon name="brain"></p-md-icon></span>Skills
                  </router-link>
                </li>
                <li v-if="$hasPermission('prompts.read')">
                  <router-link to="/library" @click.native="closeNlp">
                    <span><p-md-icon name="library"></p-md-icon></span>Library
                  </router-link>
                </li>
                <li v-if="$hasPermission('administration.read')">
                  <router-link to="/models" @click.native="closeNlp">
                    <span><p-md-icon name="chip"></p-md-icon></span>Models
                  </router-link>
                </li>
                <li v-if="$hasPermission('administration.read')">
                  <router-link to="/usage-audit" @click.native="closeNlp">
                    <span><p-md-icon name="file-chart"></p-md-icon></span>Usage Audit
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
          <li v-if="$hasPermission('templates.read')" class="nav-list-item">
            <router-link to="/rules"
              ><span><p-md-icon name="bug-check-outline"></p-md-icon></span>Rules</router-link
            >
          </li>
          <li v-if="$hasPermission('forms.read')" class="nav-list-item">
            <router-link to="/forms"
              ><span><p-icon name="forms"></p-icon></span>Forms</router-link
            >
          </li>
          <li v-if="$hasPermission('templates.read')" class="nav-list-item">
            <router-link to="/documents/word">
              <span><p-icon name="word"></p-icon></span>Word Templates
            </router-link>
          </li>
          <li v-if="$hasPermission('templates.read')" class="nav-list-item">
            <router-link to="/documents/visio">
              <span><p-icon name="visio"></p-icon></span>Visio Templates
            </router-link>
          </li>
          <li v-if="$hasPermission('templates.read')" class="nav-list-item">
            <router-link to="/shapes">
              <span><p-md-icon name="shape"></p-md-icon></span>Visio Shapes
            </router-link>
          </li>
          <li v-if="$hasPermission('templates.read')" class="nav-list-item">
            <router-link to="/drawings">
              <span><p-md-icon name="drawing-box"></p-md-icon></span>Drawings
            </router-link>
          </li>
          <li v-if="$hasPermission('messages.read')" class="nav-list-item">
            <router-link to="/messages">
              <span><p-icon name="messages"></p-icon></span>Messages
            </router-link>
          </li>
          <li v-if="$hasPermission('uspto.read')" class="nav-list-item">
            <router-link to="/uspto">
              <span><p-md-icon name="file-sync"></p-md-icon></span>USPTO dashboard
            </router-link>
          </li>
          <li v-if="$hasPermission('docketing_tasks.read')" class="nav-list-item">
            <router-link to="/fip">
              <span><p-md-icon name="folder-sync-outline"></p-md-icon></span>FIP dashboard
            </router-link>
          </li>
          <li v-if="$hasPermission('portfolio.read')" class="nav-list-item">
            <router-link to="/processing">
              <span><p-md-icon name="file-replace"></p-md-icon></span>Portfolio dashboard
            </router-link>
          </li>
          <li v-if="$hasPermission('administration.read')" class="nav-list-item">
            <router-link to="/emails-connector">
              <span><p-icon name="email"></p-icon></span>Emails Connector
            </router-link>
          </li>
          <li v-if="$hasPermission('administration.read')" class="nav-list-item">
            <router-link to="/administration">
              <span><p-icon name="settings"></p-icon></span>Administration
            </router-link>
          </li>
          <li v-if="$hasPermission('workflows.read')" class="nav-list-item">
            <router-link to="/workflows">
              <span><p-icon name="workflow"></p-icon></span>Workflows
            </router-link>
          </li>
          <li v-if="$hasPermission('docketing_tasks.read')" class="nav-list-item">
            <router-link to="/milestones">
              <span><p-md-icon name="sign-direction"></p-md-icon></span>Milestones
            </router-link>
          </li>
        </ul>
      </nav>
      <footer>
        <p-button variant="text" @click="toggleExpanded"
          ><p-icon v-if="expanded" name="left-left"></p-icon><p-icon v-else name="right-right"></p-icon
        ></p-button>
      </footer>
    </aside>
    <section v-if="hasBackofficeAccess">
      <router-view />
    </section>
    <section v-else></section>
  </section>
</template>

<script>
import { lw } from '@/utils/lw';

import Icon from './common/Icon';

import MdIcon from './common/MdIcon';
import Button from './common/Button';

const LOCAL_STORAGE_ASIDE_EXPANDED = 'LOCAL_STORAGE_ASIDE_EXPANDED';
const NLP_PATH_PREFIXES = ['/chains', '/tools', '/skills', '/library', '/models', '/usage-audit'];

export default {
  components: {
    'p-icon': Icon,
    'p-button': Button,
    'p-md-icon': MdIcon
  },
  data() {
    return {
      expanded: lw.get(LOCAL_STORAGE_ASIDE_EXPANDED),
      nlpOpen: false,
      nlpDropdownStyle: {}
    };
  },
  computed: {
    hasBackofficeAccess() {
      return this.$hasPermission('backoffice_access.read');
    },
    showNlp() {
      return this.$hasPermission('backoffice_access.read');
    },
    isNlpRoute() {
      const path = this.$route.path || '';
      return NLP_PATH_PREFIXES.some(prefix => path === prefix || path.startsWith(`${prefix}/`));
    }
  },
  watch: {
    $route() {
      this.closeNlp();
    },
    expanded() {
      if (this.nlpOpen) {
        this.$nextTick(this.positionNlpDropdown);
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeNlp);
    window.removeEventListener('resize', this.positionNlpDropdown);
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
      lw.set(LOCAL_STORAGE_ASIDE_EXPANDED, this.expanded);
    },
    toggleNlp() {
      if (this.nlpOpen) {
        this.closeNlp();
        return;
      }
      this.nlpOpen = true;
      this.$nextTick(() => {
        this.positionNlpDropdown();
        document.addEventListener('click', this.closeNlp);
        window.addEventListener('resize', this.positionNlpDropdown);
      });
    },
    positionNlpDropdown() {
      const trigger = this.$refs.nlpTrigger;
      if (!trigger || !this.nlpOpen) {
        return;
      }
      const triggerRect = trigger.getBoundingClientRect();
      const aside = trigger.closest('aside');
      const asideRect = aside ? aside.getBoundingClientRect() : triggerRect;
      // Anchor to the aside edge — collapsed mode clips the trigger, but its
      // layout box still includes hidden label width and would place the menu too far right.
      this.nlpDropdownStyle = {
        top: `${triggerRect.top}px`,
        left: `${asideRect.right + 4}px`
      };
    },
    closeNlp() {
      if (!this.nlpOpen) {
        return;
      }
      this.nlpOpen = false;
      document.removeEventListener('click', this.closeNlp);
      window.removeEventListener('resize', this.positionNlpDropdown);
    }
  }
};
</script>

<style lang="scss" scoped>
.shell {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  width: 100%;
  height: 100%;

  aside {
    color: var(--theme-on-surface);
    background-color: var(--theme-surface);
    width: 50px;
    overflow: hidden;
    display: grid;
    grid-template-rows: minmax(0, 1fr) 30px;
    nav {
      overflow-x: hidden;
    }

    .nav-list {
      display: grid;
      font-size: 1rem;
      padding: 1rem;
      grid-gap: 0.5rem;
      align-items: center;

      .nav-list-item {
        // text-transform: uppercase;
        height: 30px;
        min-width: 0;

        a,
        .nlp-trigger {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
          white-space: nowrap;
          cursor: pointer;
        }

        a.router-link-active {
          color: var(--theme-on-background);
          cursor: default;
        }

        span {
          font-size: 1.5rem;
          display: inline-flex;
          margin-right: 5px;
          width: 30px;
          height: 100%;
          align-items: center;
          flex-shrink: 0;
        }
      }

      .nlp-menu {
        position: relative;
        overflow: visible;

        .nlp-trigger {
          color: inherit;

          &.active,
          &.open {
            color: var(--theme-on-background);
          }

          .chevron {
            margin-left: auto;
            margin-right: 0;
            width: 18px;
            font-size: 1.1rem;
            opacity: 0;
            justify-content: center;
          }
        }

        .nlp-dropdown {
          position: fixed;
          min-width: 210px;
          z-index: 1000;
          background: var(--theme-surface);
          border: 1px solid var(--theme-highlight);
          border-radius: 3px;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
        }

        .nlp-dropdown-list {
          margin: 0;
          padding: 0.25rem 0;
          list-style: none;

          li {
            height: auto;

            &:not(:last-child) {
              border-bottom: 1px solid var(--theme-highlight);
            }

            a {
              display: flex;
              align-items: center;
              width: 100%;
              height: auto;
              padding: 0.55rem 0.85rem;
              box-sizing: border-box;
              white-space: nowrap;
              color: var(--theme-on-surface);
              text-decoration: none;

              &:hover {
                background-color: var(--theme-highlight);
              }

              &.router-link-active {
                color: var(--theme-on-background);
                font-weight: 600;
                cursor: default;
              }

              span {
                font-size: 1.25rem;
                width: 26px;
                margin-right: 0.5rem;
                flex-shrink: 0;
              }
            }
          }
        }
      }
    }

    footer {
      display: flex;
      width: 100%;

      justify-content: center;
      align-items: center;
    }

    &.expanded {
      width: 250px;

      footer {
        justify-content: flex-end;
      }

      .nlp-menu .nlp-trigger .chevron {
        opacity: 1;
      }
    }
  }

  aside ~ section {
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    overflow-y: auto;
  }
}
</style>
